import { Form, Input } from "antd";

const InputEmail = ({
  rules,
  placeholder,
  label,
  name,
  onChange,
  classname,
  wrapClassname,
}) => {
  const handleChange = (value) => {
    onChange?.(name, value);
  };

  return (
    <Form.Item label={label} name={name || "email"} rules={rules}>
      <Input placeholder={placeholder} onChange={handleChange} />
    </Form.Item>
  );
};

export default InputEmail;
